/**
 * SuggestedQueries - Minimalist query suggestions
 *
 * Features:
 * - Compact clickable queries
 * - Retro mission control aesthetic
 * - Keyboard accessible
 */

interface SuggestedQueriesProps {
  onSelectQuery: (query: string) => void
  disabled?: boolean
}

const SUGGESTED_QUERIES = [
  'What are the highest risk conjunction events right now?',
  'Show me upcoming emergency-reportable conjunctions',
  'What conjunction events need my attention?',
  'Ingest the latest CDM data from Space-Track',
  'Show me all conjunctions including past events',
]

function SuggestedQueries({ onSelectQuery, disabled = false }: SuggestedQueriesProps) {
  return (
    <div>
      {/* Header */}
      <div className="flex items-center gap-2 mb-3">
        <span className="text-xs font-mono uppercase tracking-wider text-retro-dim">
          Suggested queries
        </span>
        <div className="flex-1 h-px bg-retro-border" />
      </div>

      {/* Query buttons - inline */}
      <div className="flex flex-wrap gap-2">
        {SUGGESTED_QUERIES.map((query) => (
          <button
            key={query}
            onClick={() => onSelectQuery(query)}
            disabled={disabled}
            className="
              text-xs font-mono px-3 py-1.5 rounded
              border border-retro-border
              text-retro-muted
              hover:text-retro-cyan hover:border-retro-cyan
              focus:outline-none focus:ring-1 focus:ring-retro-cyan
              transition-colors
              disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:text-retro-muted disabled:hover:border-retro-border
            "
          >
            {query}
          </button>
        ))}
      </div>
    </div>
  )
}

export default SuggestedQueries
